module.exports = __webpack_public_path__ + "img/snakeGraph.9cbaa071.svg";